export default __webpack_public_path__ + "static/media/Book.3662e115.svg";